import React from "react";


function pronounce(letter) {
  const synth = window.speechSynthesis;
  const utter = new SpeechSynthesisUtterance(letter);
  utter.voice = synth.getVoices().find(v => v.name.includes("Child") || v.name.includes("Google UK English Female"));
  synth.speak(utter);
  setTimeout(() => synth.speak(utter), 1500); // repeat twice
}
export default pronounce;
